import { useTranslation } from 'react-i18next'

import { cn } from '@/shared/lib/styles/class-merge'
import { Badge } from '@/shared/ui/badge'
import { ReservationStatus } from '@monorepo/functions/src/types/reservations'

type ReservationBadgeProps = {
    reservationStatus: ReservationStatus
}

const STYLES_FROM_RESERVATION_STATUS: Record<ReservationStatus, string> = {
    confirmed: 'bg-green-500 text-white',
    pending: 'bg-yellow-500 text-black',
    cancelled: 'bg-red-500 text-white',
    'propuesta peluqueria': 'bg-yellow-50 text-yellow-800 border border-yellow-200',
    budget: 'bg-yellow-50 text-yellow-800 border border-yellow-200',
    completed: 'bg-green-500 text-white',
}

const DEFAULT_STATUS_STYLE = 'bg-yellow-500 text-black'

const TRANSLATIONS_FROM_RESERVATION_STATUS: Record<ReservationStatus, { key: string; default: string }> = {
    confirmed: { key: 'confirmed', default: 'Confirmed' },
    pending: { key: 'pending', default: 'Pending' },
    cancelled: { key: 'cancelled', default: 'Cancelled' },
    'propuesta peluqueria': { key: 'hairSalonProposal', default: 'Hair salon proposal' },
    budget: { key: 'budget', default: 'Budget' },
    completed: { key: 'completed', default: 'Completed' },
}

export const ReservationBadge = ({ reservationStatus }: ReservationBadgeProps) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'reservationBadge' })

    const translation = TRANSLATIONS_FROM_RESERVATION_STATUS[reservationStatus]

    return (
        <Badge
            className={cn(
                STYLES_FROM_RESERVATION_STATUS[reservationStatus] ?? DEFAULT_STATUS_STYLE,
                'whitespace-nowrap px-2 py-0.5 text-xs font-medium',
            )}
        >
            {translation ? t(translation.key, translation.default) : ''}
        </Badge>
    )
}
